import React from "react";
import Link from "gatsby-link";
import { Group, Button } from "rebass";
import Heading from "../components/Heading";
import styled from "styled-components";
import ButtonLink from "./ButtonLink";

const StyledLinkActive = styled(Link)`
  color: white;
  text-decoration: none;
  font-weight: bold;
`;

const Section = ({ active, name, title, to }) => {
  if (active === name) {
    return (
      <Button children={<StyledLinkActive to={to}>{title}</StyledLinkActive>} />
    );
  } else {
    return <ButtonLink to={to} title={title} />;
  }
};

const Toc = ({ active }) => (
  <div>
    <Heading fontSize={7}>Symfony 4 Workshop</Heading>
    <Group>
      <Section active={active} name="starting" title="Starting" to="/" />
      <Section
        active={active}
        name="doctrine"
        title="Doctrine"
        to="/doctrine"
      />
      <Section
        active={active}
        name="fixtures"
        title="Fixtures"
        to="/fixtures"
      />
      <Section
        active={active}
        name="controllertemplate"
        title="Controller and Template"
        to="/controllertemplate"
      />
      <Section
        active={active}
        name="encore"
        title="Assets with Webpack Encore"
        to="/encore"
      />
      <Section active={active} name="forms" title="Forms" to="/form" />
      <Section active={active} name="events" title="Events" to="/events" />
      <Section
        active={active}
        name="services"
        title="Services"
        to="/services"
      />
      <Section
        active={active}
        name="validation"
        title="Validation"
        to="/validation"
      />
      <Section active={active} name="testing" title="Testing" to="/testing" />
      <Section active={active} name="api" title="Apis" to="/api" />
      <Section active={active} name="admin" title="Admin panel" to="/admin" />
    </Group>
  </div>
);

export default Toc;



// WEBPACK FOOTER //
// ./src/components/Toc.js